import React, { useState, useEffect, useContext } from 'react';

import Box from '@mui/material/Box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

import {  getActiveUserList, stafflogin } from '../../actions/admin.actions';
import { updateNullOfObjectValues } from '../../helpers/helper';
import secureLocalStorage from 'react-secure-storage';
import CustomTabPanel from '../../ui-components/CustomTabPanel';
import DrawerHeader from '../../ui-components/DrawerHeader';
import { a11yProps } from '../../helpers/helper';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Link, useNavigate
} from "react-router-dom";
import TextField from '@mui/material/TextField';
import DownloadIcon from '@mui/icons-material/Download';

import { AppContext } from '../../context';

function Report() {

  
//define form fields
const formFields = {
  empidval: null,
  empid: '',
  email: '',
  ipuser: '',
  emp_name: '',
  
};
const [users, setUsers] = useState([]);
const [formValues, setFormValues] = useState(formFields);
const [formErrors, setFormErrors] = useState(updateNullOfObjectValues(formFields));
const [submitting, setSubmitting] = useState(false);
const [submitSuccess, setSubmitSuccess] = useState(null);
const [submitError, setSubmitError] = useState(null);
const [isEdit, setIsEdit] = useState(false);
const [editUserData, setEditUserData] = useState(null);
const navigate = useNavigate();
const { storage } = useContext(AppContext);
React.useEffect(() => {
  if (document.body.classList.contains('adminbody_bg')) {
    document.body.classList.remove('body');
  }
  document.body.classList.add('adminbody_bg');
  //get user list

  getActiveUserList({ all: 1 }).then((res) => {
    
    setUsers(res.data.data.users);
  }).catch((error) => {
    console.log(error);
  });

}, []);


const handleImpersonate = (v) => {
  setFormErrors(updateNullOfObjectValues(formFields));
  if(v!=null){
  
    setFormValues({
          ...formValues,
          empidval: v,
          empid: v.empid,
          email: v.email,
          emp_name: v.name,
        });
  }else{
    
     setFormValues(formFields);
  }

}

  
  const [value, setValue] = React.useState(0);
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    if (!formValues.empid) {
      formIsValid = false;
      errors['empid'] = 'Please Select the user';
    }

    
    setFormErrors(errors);
    return formIsValid;
  }

  const handleSubmit = () => {
    if (submitting) return;
    if (validateForm()) {
      setSubmitting(true);
      let formData = { ...formValues };
     
      stafflogin( { empid: formData.empid, emp_name: formData.emp_name,  email: formData.email}).then((res) => {
          handleSubmitResponse(res);
        }).catch((error) => {
          console.log(error);
        });
      

    }
  }

  const handleSubmitResponse = (res) => {
    setSubmitting(false);
    if (res.data.status) {
      console.log(res.data.data);
          storage[0].userdata = res.data.data;
          // localStorage.setItem("nursedata", JSON.stringify(res.data.data));
          // localStorage.setItem('nurseid', user.empid);
          secureLocalStorage.setItem("nursedata",  JSON.stringify(res.data.data));
          secureLocalStorage.setItem("nurseid",   res.data.data.empid);
           
         
      setSubmitSuccess('Staff Login Successfully!');
      setFormValues(formFields);
      setFormErrors(updateNullOfObjectValues(formFields));
      setTimeout(() => {
        setSubmitSuccess(null);
        if(res.data.data.type == 'N'){
          navigate('/application');
        }else{
          navigate('/applicationstatus');
        }
      }, 1000);
    } else {
      setSubmitError(res.data.data);
    }
  }
  return (
    <Typography paragraph>
    <div className='row'>
      <div className='col-md-12'>
        <div className='club-sec application-sec tab-main'>
          <div className='container-fluid '>

            <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec admin-top-sec' style={{ marginTop: '5px' }}>
<Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Impersonate" {...a11yProps(0)} />
        
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0} class="manage-sec-nw manage-sec-nwss imprson-nwdd">
       <div className='report-main-sec'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-4 dat-cal-sec'>
                    <div className="auto-loca login-secs imperon-sec" style={{marginTop:'8px'}}>
                    <Stack spacing={3} sx={{ width: '90%', margin: '0 auto' }}>
                      <Autocomplete
                        
                        id="tags-standard"
                        value={formValues.empidval}
                        options={users}
                        getOptionLabel={(option) => option.name+ ' ' + option.last_name + ' ('+ option.empid+')'}
                        isOptionEqualToValue={(option, value) => option.id === value.id}

                        onChange={(e,v) => handleImpersonate(v)}
                       
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Select User"
                            placeholder="Users" className='requireds'
                          />
                        )}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.id}>
                              {option.name} {option.last_name} ({option.empid})
                            </li>
                          );
                        }}
                        renderTags={(tagValue, getTagProps) => {
                          return tagValue.map((option, index) => (
                            <Chip {...getTagProps({ index })} key={option.id} label={option.name+ ' ' + option.last_name + '('+ option.empid+')'} />
                          ))
                        }}
                      />
                      {
                        formErrors.empid && <div className='help-imper-error'><FormHelperText className='manual_error'>{formErrors.empid}</FormHelperText></div>
                      }

                    </Stack>
                  </div>
                        </div>
                        
                </div>
                <div className='row'>
                <div className='col-md-4 dat-cal-sec lon-scs'>
                        <div class="login-submit login-submitss btn-adm adm-dwnss">
                    <button class="btn btn-login btn-submit bt-forms btn-downld btn-imprs" type='button' onClick={handleSubmit}>Login {submitting && <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "white" }} />} </button>
                    
                  </div>
                        </div>
                </div>

                {
                submitSuccess ?
                  <div className="custome-vali-imper custom-success-msg">
                    <p> {submitSuccess}</p>
                   
                  </div>
                  : null
              }
              {
                submitError ?
                  <div className="custome-vali-imper custom-error-msg" >
                    <p>{submitError}</p>
                  </div>
                  : null
              }
            </div>
       </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        By Location
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        By Status
      </CustomTabPanel>
    </Box>
    </div>
    </div>
    </div>
    </div>
    </div>
    </Typography>

  );
}
export default Report;

